import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0052',
    ecrans: ['00-2'],
    params: ['id', '?docaffnumdoc01', '?tydcleint']
});
